import { render } from "./RestaurantCard.vue?vue&type=template&id=bdbaf2c0&scoped=true"
import script from "./RestaurantCard.vue?vue&type=script&lang=js"
export * from "./RestaurantCard.vue?vue&type=script&lang=js"

import "./RestaurantCard.vue?vue&type=style&index=0&id=bdbaf2c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdbaf2c0"]])

export default __exports__